import { useRouter } from 'next/router';
import qs from 'qs';

const URL_QUERY_PARAMETERS_STORAGE_KEY = 'URL_QUERY_PARAMETERS_STORAGE_KEY';

export enum UrlQueryParamtersStorageEnum {
  landingPage = 'landingPage',
}
export const useUrlQueryParameters = (config?: { urlKey: UrlQueryParamtersStorageEnum }) => {
  const { urlKey } = config || {};
  const router = useRouter();

  /**
   * methods
   */
  const updateStoredQueryParams = () => {
    if (!urlKey) {
      return;
    }

    let data = {};
    try {
      data = JSON.parse(sessionStorage.getItem(URL_QUERY_PARAMETERS_STORAGE_KEY)) || {};
    } catch (_) {}
    data[urlKey] = router.query;
    sessionStorage.setItem(URL_QUERY_PARAMETERS_STORAGE_KEY, JSON.stringify(data));
  };

  const getTheUrlQueryParams = (theUrlKey) => {
    if (!theUrlKey) {
      return;
    }

    let data = {};
    try {
      data = JSON.parse(sessionStorage.getItem(URL_QUERY_PARAMETERS_STORAGE_KEY)) || {};
    } catch (_) {}
    return data[theUrlKey];
  };

  const getBusinessInsuranceCompleteLink = (params = {}) => {
    return `/personal/business-insurance?${qs.stringify({
      ...getTheUrlQueryParams(UrlQueryParamtersStorageEnum.landingPage),
      ...params,
    })}`;
  };

  return {
    updateStoredQueryParams,
    getTheUrlQueryParams,
    getBusinessInsuranceCompleteLink,
  };
};
